import { alertReducer } from './alert';
import { chatActionModalReducer } from './chatActionModal';
import { chatCustomActionModalReducer } from './chatCustomActionModal';
import { chatImagesReducer } from './chatImages';
import { chatListReducer } from './chatList';
import { chatOperationsReducer } from './chatOperations';
import { contentFullscreenReducer } from './contentFullscreen';
import { errorPageReducer } from './errorPage';
import { firstMessageReducer } from './firstMessage';
import { hintQuestionsReducer } from './hintQuestions';
import { internetStatusReducer } from './internetStatus';
import { masterFiltersReducer } from './masterFilters';
import { messagesReducer } from './messages';
import { mobileSideReducer } from './mobileSide';
import { offersForSelectionReducer } from './offersForSelection';
import { openedChatsReducer } from './openedChats';
import { routeReducer } from './route';
import { sessionReducer } from './session';
import { socketReducer } from './socket';
import { subAgentsReducer } from './subAgents';
import { unreadMessagesCountReducer } from './unreadMessagesCount';
import { uploadFilesReducer } from './uploadFiles';
import { userCardReducer } from './userCard';
import { usersStatusReducer } from './usersStatus';
import { IAppStore } from '../store/createAppStore';

export function attachReducers(store: IAppStore) {
  store.addReducer(internetStatusReducer);
  store.addReducer(errorPageReducer);
  store.addReducer(socketReducer);
  store.addReducer(sessionReducer);
  store.addReducer(mobileSideReducer);
  store.addReducer(chatListReducer);
  store.addReducer(routeReducer);
  store.addReducer(alertReducer);
  store.addReducer(openedChatsReducer);
  store.addReducer(messagesReducer);
  store.addReducer(firstMessageReducer);
  store.addReducer(chatOperationsReducer);
  store.addReducer(contentFullscreenReducer);
  store.addReducer(uploadFilesReducer);
  store.addReducer(chatActionModalReducer);
  store.addReducer(usersStatusReducer);
  store.addReducer(userCardReducer);
  store.addReducer(chatImagesReducer);
  store.addReducer(hintQuestionsReducer);
  store.addReducer(chatCustomActionModalReducer);
  store.addReducer(offersForSelectionReducer);
  store.addReducer(masterFiltersReducer);
  store.addReducer(subAgentsReducer);
  store.addReducer(unreadMessagesCountReducer);
}
